import { queryOptions } from "@tanstack/react-query";
import { z } from "zod";

import { graphqlClient } from "@/api/graphql";
import { graphql } from "@/generated/digitalnisklady.cz";
import { Country } from "@/generated/digitalnisklady.cz/graphql";

// eslint-disable-next-line lingui/no-unlocalized-strings
const companiesDocument = graphql(`
  query Companies {
    user {
      companies {
        edges {
          node {
            id
            name
            vatNumber
            identificationNumber
            country
          }
        }
      }
    }
  }
`);

type Companies = z.infer<typeof companiesSchema>;
const companiesSchema = z.array(
  z.object({
    country: z.enum(Country),
    id: z.string(),
    identificationNumber: z.string(),
    name: z.string(),
    vatNumber: z.string().optional().nullable(),
  }),
);

const companiesQuery = () =>
  queryOptions({
    queryFn: () => graphqlClient.request(companiesDocument),
    queryKey: ["erp", "companies"],
    select: (data) => {
      const result = data.user?.companies?.edges?.map((company) => ({
        country: company?.node?.country,
        id: company?.node?.id,
        identificationNumber: company?.node?.identificationNumber,
        name: company?.node?.name,
        vatNumber: company?.node?.vatNumber,
      }));

      return companiesSchema.parse(result);
    },
    staleTime: Infinity,
  });

export { companiesQuery };
export type { Companies };
